import { render, staticRenderFns } from "./NewDraggableListComponent.vue?vue&type=template&id=02966c83&scoped=true"
import script from "./NewDraggableListComponent.vue?vue&type=script&lang=js"
export * from "./NewDraggableListComponent.vue?vue&type=script&lang=js"
import style0 from "./NewDraggableListComponent.vue?vue&type=style&index=0&id=02966c83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02966c83",
  null
  
)

export default component.exports